import { LandingPageConfigView } from "@tlc/ls2pac/app/views/myAccountViews/configSubViews/LandingPageConfigView";
import * as React from "react";
import { useRouteLoaderData } from "react-router-dom";
import { LoaderData, myAccountLoader } from "../account/MyAccount";
import { useAccount } from "../../Account";

export const LandingPageConfigPage: React.FC = () => {
  const { accountSummary, user, patron } = useAccount();
  // const {accountSummary, user} = useRouteLoaderData("config") as LoaderData<typeof myAccountLoader>;

  React.useEffect(() => {
    const view = new LandingPageConfigView();
    view.load(
      { accountSummary, patron },
      user,
      document.getElementById("landingPageConfigContainer"),
      "landingPageConfigTab"
    );

    return () => {
      view?.cleanup();
    };
  }, []);
  return <div id="landingPageConfigContainer"></div>;
};
